import React, { useState, useEffect } from 'react';
import TaskSummary from '../../components/common/TaskSummary';

const AdminDashboard = () => {
    const [activeJobs, setActiveJobs] = useState(0);
    const [inactiveJobs, setInactiveJobs] = useState(0);
    const [totalJobs, setTotalJobs] = useState(0);
    const [activeCompanies, setActiveCompanies] = useState(0);
    const [inactiveCompanies, setInactiveCompanies] = useState(0);
    const [totalCompanies, setTotalCompanies] = useState(0);
    const [activeJobSeekers, setActiveJobSeekers] = useState(0);
    const [inactiveJobSeekers, setInactiveJobSeekers] = useState(0);
    const [totalJobSeekers, setTotalJobSeekers] = useState(0);

    useEffect(() => {
        const fetchJobStats = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/stats/jobs`);
                if (!response.ok) {
                    throw new Error('Failed to fetch job stats');
                }
                const data = await response.json();
                console.log('Job stats response:', data);
                setActiveJobs(data.activeCount || 0);
                setInactiveJobs(data.inactiveCount || 0);
                setTotalJobs(data.totalCount || 0);
            } catch (error) {
                console.error('Error fetching job stats:', error);
            }
        };

        const fetchCompanyStats = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/stats/companies`);
                if (!response.ok) {
                    throw new Error('Failed to fetch company stats');
                }
                const data = await response.json();
                console.log('Company stats response:', data);
                setActiveCompanies(data.activeCount || 0);
                setInactiveCompanies(data.inactiveCount || 0);
                setTotalCompanies(data.totalCount || 0);
            } catch (error) {
                console.error('Error fetching company stats:', error);
            }
        };

        const fetchJobSeekerStats = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/stats/jobseekers`);
                if (!response.ok) {
                    throw new Error('Failed to fetch job seeker stats');
                }
                const data = await response.json();
                console.log('Job seeker stats response:', data);
                setActiveJobSeekers(data.activeCount || 0);
                setInactiveJobSeekers(data.inactiveCount || 0);
                setTotalJobSeekers(data.totalCount || 0);
            } catch (error) {
                console.error('Error fetching job seeker stats:', error);
            }
        };

        fetchJobStats();
        fetchCompanyStats();
        fetchJobSeekerStats();
    }, []);

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold text-gray-900 mb-6">Dashboard</h1>
            {/* Task Summary Section */}
            <div className="mb-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Task Overview</h2>
                <TaskSummary />
            </div>
            {/* Dashboard content */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-lg font-semibold text-gray-700 mb-2">Jobs : {totalJobs}</h2>
                    <p className="text-xl text-green-600">Active: {activeJobs}</p>
                    <p className="text-xl text-red-600">Inactive: {inactiveJobs}</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-lg font-semibold text-gray-700 mb-2">Companies & Recruiters : {totalCompanies}</h2>
                   <p className="text-xl text-green-600">Active: {activeCompanies}</p>
                    <p className="text-xl text-red-600">Inactive: {inactiveCompanies}</p>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <h2 className="text-lg font-semibold text-gray-700 mb-2">Job Seekers : {totalJobSeekers}</h2>
                    <p className="text-xl text-green-600">Active: {activeJobSeekers}</p>
                    <p className="text-xl text-red-600">Inactive: {inactiveJobSeekers}</p>
                </div>
            </div>
            {/* Recent Activity */}
            <div className="mt-8">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Recent Activity</h2>
                <div className="bg-white rounded-lg shadow overflow-hidden">
                    <div className="p-4 text-gray-500 text-center">
                        No recent activity
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;